import * as models from "./api/models";

export default function isReviewKey(value: string): value is models.ReviewKeys {
    return !!Object.values(models.ReviewKeys).find((key) => key === value);
}
